import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=7d8ff532"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=7d8ff532&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports